import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Select as SelectView, SelectMulti as SelectMultiView, useSelect, useSelectMulti } from '.';
import { wrap } from '@atlasgroup/react-wrap';
import { WrapperHorizontal } from '../../gatsby-theme-docz/components/Wrapper';
export const SelectMulti = wrap(SelectMultiView, useSelectMulti);
export const Select = wrap(SelectView, useSelect);
export const options = [{
  value: 'UK',
  label: 'England 🇬🇧'
}, {
  value: 'CZ',
  label: 'Czech Republic 🇨🇿'
}];
export const _frontmatter = {};
const layoutProps = {
  SelectMulti,
  Select,
  options,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <h1 {...{
      "id": "select"
    }}>{`Select`}</h1>
    <p>{`Is an alternative to the `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select"
      }}><inlineCode parentName="a">{`<select>`}</inlineCode></a>{` element.`}</p>
    <h2 {...{
      "id": "common-usage"
    }}>{`Common usage`}</h2>
    <blockquote>
      <p parentName="blockquote"><inlineCode parentName="p">{`Select`}</inlineCode>{` must be wrapped with `}<inlineCode parentName="p">{`useSelect`}</inlineCode>{` to make the element interactive. Using the component with a custom hook is encouraged.`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { Select, useSelect, styled } from '@atlasgroup/react-atlantic';
import { wrap } from '@atlasgroup/react-wrap';

// Optional
const ProjectSpecificStyledSelect = styled(Select)\`
    // ... Project specific styles ...
\`;

const ProjectSpecificSelect = wrap(ProjectSpecificStyledSelect, useSelect);
`}</code></pre>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<Select options={options} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      SelectView,
      SelectMultiView,
      useSelect,
      useSelectMulti,
      wrap,
      WrapperHorizontal,
      DefaultLayout,
      SelectMulti,
      Select,
      options,
      _frontmatter
    }} mdxType="Playground">
    <Select options={options} mdxType="Select" />
    </Playground>
    <h2 {...{
      "id": "sizes"
    }}>{`Sizes`}</h2>
    <Playground __position={1} __code={'<WrapperHorizontal>\n  <Select options={options} size=\"small\" />\n  <Select options={options} size=\"medium\" />\n  <Select options={options} size=\"large\" />\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      SelectView,
      SelectMultiView,
      useSelect,
      useSelectMulti,
      wrap,
      WrapperHorizontal,
      DefaultLayout,
      SelectMulti,
      Select,
      options,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <Select options={options} size="small" mdxType="Select" />
        <Select options={options} size="medium" mdxType="Select" />
        <Select options={options} size="large" mdxType="Select" />
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "full-width"
    }}>{`Full width`}</h2>
    <Playground __position={2} __code={'<Select options={options} isFullWidth />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      SelectView,
      SelectMultiView,
      useSelect,
      useSelectMulti,
      wrap,
      WrapperHorizontal,
      DefaultLayout,
      SelectMulti,
      Select,
      options,
      _frontmatter
    }} mdxType="Playground">
    <Select options={options} isFullWidth mdxType="Select" />
    </Playground>
    <h2 {...{
      "id": "other-views"
    }}>{`Other views`}</h2>
    <h3 {...{
      "id": "multi"
    }}>{`Multi`}</h3>
    <blockquote>
      <p parentName="blockquote"><inlineCode parentName="p">{`SelectMulti`}</inlineCode>{` should be wrapped with `}<inlineCode parentName="p">{`useSelectMulti`}</inlineCode>{`.`}</p>
    </blockquote>
    <Playground __position={3} __code={'<SelectMulti options={options} />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      SelectView,
      SelectMultiView,
      useSelect,
      useSelectMulti,
      wrap,
      WrapperHorizontal,
      DefaultLayout,
      SelectMulti,
      Select,
      options,
      _frontmatter
    }} mdxType="Playground">
    <SelectMulti options={options} mdxType="SelectMulti" />
    </Playground>
    <h2 {...{
      "id": "known-issues"
    }}>{`Known issues`}</h2>
    <ul>
      <li parentName="ul">{`[#1]`}{` - Unnecessary wrapping of the component in each project`}</li>
      <li parentName="ul">{`[#2]`}{` - The component is not accessible via keyboard (might be useful for accessibility)`}</li>
      <li parentName="ul">{`[#3]`}{` - Third party component is used`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      